'use client';

import { Footer, type Languages, Text } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import { getPrefooterColors, type PrefooterVariant } from 'app/services/get-prefooter-colors';
import { useChangeLanguage } from 'app/services/use-change-language';
import cn from 'clsx';
import { locales } from 'i18n/navigation';
import { useLocale } from 'next-intl';
import { useInAppBrowser } from 'services/hooks/use-in-app-browser';
import { getFooterLinks } from 'services/navigation/footer';
import css from './footer.module.css';
import { useOpenRolesExist } from '@/app/services/providers/open-role-context';
type FooterComponentProps = {
  variant?: PrefooterVariant;
  utm_campaign?: string;
  className?: string;
};
export default function FooterComponent({
  utm_campaign = '',
  className,
  variant = 'neutral'
}: FooterComponentProps) {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'common');
  const isInAppBrowser = useInAppBrowser();
  const {
    changeLanguage
  } = useChangeLanguage();
  const openRolesExist = useOpenRolesExist();
  const footerLinks = getFooterLinks({
    t,
    utm_campaign,
    openRolesExist
  });
  if (isInAppBrowser) {
    return null;
  }
  return <Footer className={cn(css.footer, className)} variant="socialColumn" title={<Text size="body-base" weight="medium">
                    {t('joinMillionsPeople')}
                </Text>} homeLink="/home" homeAlternateText={t('home')} columnLinks={footerLinks.columnLinks} bottomLinks={footerLinks.bottomLinks} currentLanguage={locale as Languages} supportedLanguages={locales as Languages[]} onLangSelected={(newLang: string) => changeLanguage(locale, newLang)} socialLinks={footerLinks.socialLinks} {...getPrefooterColors(variant)} data-sentry-element="Footer" data-sentry-component="FooterComponent" data-sentry-source-file="footer.tsx" />;
}